import { Basic } from '../basic.js';
import { Inputs } from '../../lib/inputs.js';
import { MSToolbar } from '../trend/toolbar.js';
import { Converter } from '../../observer/converter.js';
import { DataTypes } from 'generated';
import { getFormattedValue, exportTextfile } from '../../lib/utils.js';
import { MSNumericUpDown } from '../numericupdown/numericupdown.js';
import { MSCheckBox } from '../checkbox/checkbox.js';
import { MSDateTimePicker } from '../dtpicker/dtpicker.js';
import { MSInterval } from '../interval/interval.js';
import { styleTabulator } from '../../styles/styleTabulator.js'

/**
 * @class MSDictionary
 * @extends Basic
 * @classdesc Справочник
 * */
export class MSDictionary extends Basic {

    static get observedAttributes() {
        return super.observedAttributes.concat([
            'headerrowstyle',
            'tablecolumns',
            'rowstyle',
            'cellsstyle',
            'fieldstyles',
            'disableadd',
            'disabledelete',
            'disableedit',
            'filter',
            'gridtype',
            'sorter',
            'filrets'
        ]);
    }

    constructor() {
        super();
        if (typeof window.customElements.get('ms-numericupdown') === 'undefined') {
            window.customElements.define('ms-numericupdown', MSNumericUpDown);
        }
        if (typeof window.customElements.get('ms-dtpicker') === 'undefined') {
            window.customElements.define('ms-dtpicker', MSDateTimePicker);
        }
        if (typeof window.customElements.get('ms-interval') === 'undefined') {
            window.customElements.define('ms-interval', MSInterval);
        }
        if (typeof window.customElements.get('ms-checkbox') === 'undefined') {
            window.customElements.define('ms-checkbox', MSCheckBox);
        }
        if (!window.customElements.get('ms-toolbar', MSToolbar)) { window.customElements.define('ms-toolbar', MSToolbar); }
        const shadowRoot = this.attachShadow({ mode: 'open' });
        shadowRoot.innerHTML = `<style>
            [class^="hmi-j-"], [class*=" hmi-j-"] {
                /* use !important to prevent issues with browser extensions that change fonts */
                font-family: 'hmi' !important;
                speak: none;
                font-style: normal;
                font-weight: normal;
                font-variant: normal;
                text-transform: none;
                line-height: 1;
            }
            .hmi-j-filter:before {
                content: "\\e90e";
            }
            span.disable {
                display: none;
            }
            .tabulator{
                height: inherit;
                height: -webkit-fill-available;         
            }
            .tabulator .tabulator-header .tabulator-col.tabulator-sortable .tabulator-col-title {
                padding-right: 4px; /** уменьшаем дефолтный (из библиотеки) отступ до стрелочки */
            }
        </style>
        <style></style>
        <style>${styleTabulator}</style>
        <div>
            <ms-toolbar id='toolbar' style="display: flex; width: 100%; height: 30px; position: relative;"
            buttons='[{"method": "_getTable", "class": "hmi-j-reload", "tooltip": "${i18next.t('dictionary_toolbar_reload')}", "type": "button"},
            {"method": "_addRec", "class": "hmi-j-add", "tooltip": "${i18next.t('dictionary_toolbar_add')}", "type": "button"},
            {"method": "_edRec", "class": "hmi-j-edit", "tooltip": "${i18next.t('dictionary_toolbar_edit')}", "type": "button"},
            {"method": "_delRec", "class": "hmi-j-delete", "tooltip": "${i18next.t('dictionary_toolbar_delete')}", "type": "button"},
            {"type": "expander"},
            {"method": "ClearOptions", "class": "hmi-j-reset_settings", "tooltip": "${i18next.t('dictionary_toolbar_reset')}", "type": "button"}]'></ms-toolbar>
            <div style="height: inherit; height: -webkit-fill-available;">
                <div id="dict"></div>
            </div>
        </div>
        <div id="inbox"></div>`;

        this._main = shadowRoot.querySelector('div#dict');
        this._style = shadowRoot.querySelectorAll('style')[1];
        this._in = shadowRoot.querySelector('#inbox');

        this._toolBar = shadowRoot.getElementById('toolbar');
        this._toolBar.height = 40;
        this._toolBar.context = this;

        this._mainTable = { data: [], fields: [] };
        this._refsTable = {};
        this._filters = {};
        this._gridtype = 0;
        if (!this._tablecolumns) this._tablecolumns = JSON.parse(this.getAttribute('tablecolumns'))?.column ?? [];
        if (!Array.isArray(this._tablecolumns)) this._tablecolumns = [this._tablecolumns];
        if (!this._headerstyle) this._headerstyle = JSON.parse(this.attributes.headerrowstyle ? this.attributes.headerrowstyle.value : "{}");
        this._dictId = Number(this.getAttribute('paneldatasource'));
        this.afterSwitch = this.afterSwitch.bind(this);
        window.addEventListener("ms_message", this.afterSwitch);
        this.setPm();
    }
    setPm() {
        if ($pm.hasPermissions) {
            const _edRec = $pm.checkAllow($pm.getEntryFromElement(this, 'DirectoryEdit'))
            this._toolBar.setEnable(this._toolBar.elements["_edRec"], _edRec);

            const _addRec = $pm.checkAllow($pm.getEntryFromElement(this, 'DirectoryAdd'))
            this._toolBar.setEnable(this._toolBar.elements["_addRec"], _addRec);

            const _delRec = $pm.checkAllow($pm.getEntryFromElement(this, 'DirectoryDelete'))
            this._toolBar.setEnable(this._toolBar.elements["_delRec"], _delRec);
        }
    }
    afterSwitch(message) {
        const data = message.data;
        switch (data.event) {
            case "afterswitch":
                if ($pm.hasPermissions) {
                    const col = this.table.getColumns();
                    for (const iterator of col) {
                        const el = iterator.getElement().querySelector('span.hmi-j-filter');
                        if (el) {
                            if ($pm.checkAllow($pm.getEntryFromElement(this, 'DirectoryFilter'))) {
                                el.classList.remove('disable');
                            } else {
                                el.classList.add('disable');
                            }
                        }
                    }
                    this.table.redraw(true);
                    this.setPm();
                }
                break;
        }
    }

    /**
    * Метод возврата к проектному состоянию
    */
    ClearOptions() {
        const colSort = [];
        for (let i = 0; i < this._tablecolumns.length; i++) {
            if (this._tablecolumns[i].sort != 0) {
                colSort.push({
                    dir: this._tablecolumns[i].sort == 1 ? 'asc' : 'desc',
                    position: this._tablecolumns[i].sortposition,
                    column: this._tablecolumns[i].field
                });
            }
        }
        colSort.sort((a, b) => {
            return a.position - b.position;
        });
        const cols = this.table.getColumns();
        for (let i = 0; i < cols.length; i++) {
            const col = cols[i];
            if (this._headerstyle && this._headerstyle.backgroundcolorfilter) {
                col.getElement().style.backgroundColor = this._headerstyle.backgroundcolor;
                col.getElement().firstChild.firstChild.style.color = this._headerstyle.textcolor;
            } else {
                col.getElement().style.filter = '';
            }
        }

        this.table.setSort(colSort);
        this.saveItemState({ filrets: {} });
        this.filrets = {};
    }

    get gridtype() {
        return this._gridtype;
    }
    set gridtype(v) {
        this._gridtype = Number(v);
        this.genRowStyle();
    }

    genRowStyle() {
        this._style.innerHTML = `
        .tabulator-row {
          ${this._gridtype === 1 || this._gridtype === 2 ? `border-bottom: 1px solid gray !important;` : `border-bottom: 1px none !important;`};
        }
        .tabulator-cell {
          ${this._gridtype === 0 || this._gridtype === 2 ? `border-right: 1px solid gray !important;` : `border-right: 1px none !important;`};
        }`;
    }

    get disableadd() {
        return this._disableadd;
    }
    set disableadd(v) {
        this._disableadd = this._toBool(v);
        this._toolBar.setVisible(this._toolBar.elements['_addRec'], !this._disableadd);
    }

    get disabledelete() {
        return this._disabledelete;
    }
    set disabledelete(v) {
        this._disabledelete = this._toBool(v);
        this._toolBar.setVisible(this._toolBar.elements['_delRec'], !this._disabledelete);
    }

    get disableedit() {
        return this._disableedit;
    }
    set disableedit(v) {
        this._disableedit = this._toBool(v);
        this._toolBar.setVisible(this._toolBar.elements['_edRec'], !this._disableedit);
    }

    get filter() {
        return this._filter;
    }
    set filter(val) {
        this._filter = val;
        if (this._inited) {
            if (this._inputs && this._inputs.close) this._inputs.close();
            this._getTable();
        }
    }

    async _getTable(id) {
        if (id instanceof MouseEvent) {
            id.stopPropagation();
            id = undefined;
        }
        const fields = this._tablecolumns.map(el => {
            return el.field;
        });
        if (!fields.length) return
        const pack = {
            table: this._dictId,
            fields: fields
        };
        if (typeof id !== 'undefined') {
            pack.recId = id;
        }
        if (this._filter) {
            pack.filter = this._filter;
        }
        const options = {
            method: 'GetTableData',
            methodType: 'single',
            pack
        }
        await $sw.ServerAdapter.sendRequest(options, data => {
            if (data.code !== 0) {
                $ns.add({ type: 'error', time: new Date().toLocaleString(), title: i18next.t('title_dictionary_error_retrieving_data'), text: `ID: ${this.id}</br>errro code:${data.hex}</br>description:${data.error_text}` });
                return;
            }
            if (typeof id !== 'undefined') {
                const el = data.tables[data.main].data[id];
                const nf = [];
                for (let i = 0; i < el.length; i++) {
                    const indexs = this._findFilds(this._mainTable.fields, pack.fields[i]);
                    for (let iin = 0; iin < indexs.length; iin++) {
                        nf[indexs[iin]] = el[i];
                    }
                }
                const indexs = this._findFilds(this._mainTable.fields, this._mainTable.pk.name);
                for (let iin = 0; iin < indexs.length; iin++) {
                    nf[indexs[iin]] = id;
                }
                this._mainTable.data[id] = nf;
                const updateItem = {
                    '$__index': id,
                    '$key': id
                };

                for (let i = 0; i < this._mainTable.fields.length; i++) {
                    const f = this._mainTable.fields[i];
                    updateItem[f.name.replace(/\./mg, '$')] = nf[i];
                }
                this.table.updateOrAddData([updateItem]);
            } else {
                for (const key in data.refs) {
                    const el = data.refs[key];
                    const fields = {};
                    for (let i = 0; i < data.tables[el.table].fields.length; i++) {
                        const fEl = data.tables[el.table].fields[i];
                        fields[fEl.name] = i;
                    }

                    this._refsTable[key.replace(/\./mg, '$')] = {
                        data: data.tables[el.table].data,
                        fields: fields,
                        field: el.field
                    }
                }
                this._displayField = data.tables[data.main]['displayField'];
                this._mainTable = data.tables[data.main];
                this._updateData();
            }
        })
    }

    _addTable(pack) {
        const options = {
            method: 'InsertTableData',
            methodType: 'single',
            pack
        };

        $sw.ServerAdapter.sendRequest(options, data => {
            if (data.code !== 0) {
                $ns.add({ type: 'error', time: new Date().toLocaleString(), title: i18next.t('title_dictionary_error_retrieving_data'), text: `ID: ${this.id}</br>errro code:${data.hex}</br>description:${data.error_text}` });
                return;
            } else {
                let key = Converter._convert(data.pk, this._mainTable.pk.type);
                this._getTable(key);

            }
        });
    }

    _updateTable(pack) {
        const options = {
            method: 'UpdateTableData',
            methodType: 'single',
            pack
        };

        $sw.ServerAdapter.sendRequest(options, data => {
            if (data.code !== 0) {
                $ns.add({ type: 'error', time: new Date().toLocaleString(), title: i18next.t('title_dictionary_error_saving'), text: `ID: ${this.id}</br>errro code:${data.hex}</br>description:${data.error_text}` });
                return;
            } else {
                for (const key in pack.data) {
                    if (pack.data.hasOwnProperty(key)) {
                        this._getTable(key);
                    }
                }
            }
        });
    }

    _findFilds(filds, name) {
        const ar = [];
        for (let i = 0; i < filds.length; i++) {
            const element = filds[i];
            if (element.name.startsWith(name)) ar.push(i);
        }
        return ar;
    }

    _deleteFromTable(pack) {
        const options = {
            method: 'DeleteTableData',
            methodType: 'single',
            pack
        };
        $sw.ServerAdapter.sendRequest(options, data => {
            if (data.code !== 0) {
                $ns.add({ type: 'error', time: new Date().toLocaleString(), title: i18next.t('title_dictionary_error_deleting'), text: `ID: ${this.id}</br>errro code:${data.hex}</br>description:${data.error_text}` });
                return;
            } else {
                this.table.getSelectedRows()[0].delete();
            }
        });
    }

    get sorter() {
        return this._sorter;
    }
    set sorter(v) {
        this._sorter = v;
        if (!this.isTableBuilt) return
        if (this.table) this.table.setSort(v);
    }

    get filrets() {
        return this._filters;
    }
    set filrets(v) {
        this._filters = v;
        if (typeof this.table === 'undefined') return;
        this._setFilterToTable();
        for (const key in this._filters) {
            const col = this.table.getColumn(key);
            if (col) {
                if (this._headerstyle && this._headerstyle.backgroundcolorfilter) {
                    col.getElement().style.backgroundColor = this._headerstyle.backgroundcolorfilter;
                    col.getElement().firstChild.firstChild.style.color = this._headerstyle.textcolorfilter;
                } else {
                    col.getElement().style.filter = `brightness(${this._headerAkcent})`;
                }
            }
        }

    }

    _createTable() {
        this.columns = [];
        this._keyColums = {};
        if (!this._headerstyle) this._headerstyle = JSON.parse(this.attributes.headerrowstyle.value);
        if (!this._tablecolumns) this._tablecolumns = JSON.parse(this.getAttribute('tablecolumns'))?.column ?? [];

        let colSort = [];

        const fnSize = document.createElement('span');
        fnSize.style.fontSize = this._headerstyle.fontsize;
        fnSize.style.fontStyle = this._toBool(this._headerstyle.fontitalic) ? 'italic' : 'normal';
        fnSize.style.textDecoration = this._toBool(this._headerstyle.fontunderlined) ? 'underline' : '';
        fnSize.style.fontWeight = this._toBool(this._headerstyle.fontbold);
        fnSize.style.fontFamily = '"' + this._headerstyle.fontname + '"';
        document.body.appendChild(fnSize);

        for (let i = 0; i < this._tablecolumns.length; i++) {
            if (this._tablecolumns[i].sort != 0) {
                colSort.push({
                    dir: this._tablecolumns[i].sort == 1 ? 'asc' : 'desc',
                    position: this._tablecolumns[i].sortposition,
                    column: this._tablecolumns[i].field
                });
            }
            switch (this._tablecolumns[i].displayname) {
                case "Город":
                    this._tablecolumns[i].displayname = i18next.t("dictionary_city")
                    break;
                case "Улица":
                    this._tablecolumns[i].displayname = i18next.t("dictionary_street")
                    break;
                case "Корпус":
                    this._tablecolumns[i].displayname = i18next.t("dictionary_building");
                    break;
                case "Дом":
                    this._tablecolumns[i].displayname = i18next.t("dictionary_house");
                    break;
                default: this._tablecolumns[i].displayname
            }
            const w = Number(this._tablecolumns[i].columnwidth);
            const ind = this.columns.push({
                title: this._tablecolumns[i].displayname,
                field: this._tablecolumns[i].field.replace(/\./mg, '$'),
                visible: this._toBool(this._tablecolumns[i].visibility),
                formatterParams: { format: this._tablecolumns[i].valueformat, cel: this._tablecolumns[i] },
                titleFormatterParams: { cel: this._tablecolumns[i] },
                hozAlign: window._enums.AlignText[this._tablecolumns[i].horizontalalign],
                sorterParams: { format: this._tablecolumns[i].valueformat, cel: this._tablecolumns[i] },
                sorter: (a, b, aRow, bRow, column, dir, sorterParams) => {
                    const field = column.getField()
                    let a1 = a, b1 = b;
                    if (this._refsTable[field]) {
                        if (!this._refsTable[field].data[a]) return 1;
                        if (!this._refsTable[field].data[b]) return -1;
                        const i = this._refsTable[field].fields[this._refsTable[field].field];
                        a1 = this._refsTable[field].data[a][i];
                        b1 = this._refsTable[field].data[b][i];
                    }
                    if (sorterParams.cel.fieldtype === 'STRING') {
                        if (a1 > b1) {
                            return 1;
                        }
                        if (a1 < b1) {
                            return -1;
                        }
                        return 0;
                    }

                    return a1 - b1; //you must return the difference between the two values
                },
                formatter: (cell, formatterParams, onRendered) => {
                    const field = cell.getField();
                    const timeOffset = (new Date(cell.getValue()).getTimezoneOffset()) * 60000;
                    if (this._refsTable[field]) {
                        if (cell.getValue()) {
                            const i = this._refsTable[field].fields[this._refsTable[field].field];
                            return this._refsTable[field].data[cell.getValue()][i];
                        }
                        return cell.getValue();
                    } else {
                        const ft = formatterParams.cel.fieldtype;
                        let format = formatterParams.format || formatterParams.cel.valueformat;
                        cell.getElement().style.textAlign = window._enums.AlignText[formatterParams.cel.horizontalalign];
                        let val = cell.getValue();
                        switch (ft) {
                            case 'DATE':
                                format = format ? format : 'dd-MM-yyyy';
                                val += timeOffset;
                                break;
                            case 'DATE_AND_TIME':
                                format = format ? format : 'dd-MM-yyyy HH:mm:ss';
                                val += timeOffset;
                                break;
                            case 'TIME':
                                format = format ? format : 'dd.HH:mm:ss';
                                val += timeOffset;
                                break;
                            case 'TOD':
                            case 'TIME_OF_DAY':
                                format = format ? format : 'HH:mm:ss';
                                break;
                            default:
                                if (this.enums(ft)) {
                                    val = this.enums(ft)[val];
                                }
                        }

                        return getFormattedValue(format, val, ft);
                    }
                    // return cell.getValue();
                },
                headerClick: (e, col) => {
                    if (e.target.tagName === 'SPAN') {
                        e.stopImmediatePropagation();
                        const field = col.getField();
                        const indexOf = this._tablecolumns.findIndex(e => {
                            return e.field.replace(/\./mg, '$') === field;
                        });
                        if (indexOf > -1) {
                            let options;
                            const inputNum = new Inputs(this._main);
                            const title = `${i18next.t('dictionary_title_filter_for')} ${this._tablecolumns[indexOf].displayname}`;
                            if (this._filters) {
                                this._oldFilters = JSON.parse(JSON.stringify(this._filters));
                            }
                            switch (this._tablecolumns[indexOf].fieldtype) {
                                case 'TIME':
                                    options = { timeformat: this._tablecolumns[indexOf].valueformat, utc: false };
                                    const val_min_t = this._filters[field] && this._filters[field]['min'] ? this._filters[field]['min'].value : '';
                                    const val_max_t = this._filters[field] && this._filters[field]['max'] ? this._filters[field]['max'].value : '';
                                    inputNum.inputBoxIntervalRange(e, title, { min: val_min_t, max: val_max_t }, options, (res) => {
                                        if (res == null) return;
                                        let setFilt = true;
                                        let text = [];
                                        if (isNaN(res.min) && isNaN(res.max)) {
                                            delete this._filters[field];
                                            setFilt = false;
                                        } else {
                                            this._filters[field] = {};
                                            if (!isNaN(res.min)) {
                                                this._filters[field]['min'] = {
                                                    field: field,
                                                    type: '>=',
                                                    value: res.min
                                                };
                                                text.push(`>= ${res.min}`);
                                            }
                                            if (!isNaN(res.max)) {
                                                this._filters[field]['max'] = {
                                                    field: field,
                                                    type: '<=',
                                                    value: res.max
                                                };
                                                text.push(`<= ${res.max}`);
                                            }
                                            if (field.indexOf('$') > -1) {
                                                this._filters[field].ref = this._refsTable[field];
                                                this._filters[field].func = this.refFilter.bind(this);
                                                this._filters[field].max && (this._filters[field].max.field = this.refFilter.bind(this, field));
                                                this._filters[field].min && (this._filters[field].min.field = this.refFilter.bind(this, field));
                                            }
                                        }
                                        this._setFilter(col, setFilt, text.join(', '));
                                    });
                                    break;
                                case 'TOD':
                                    if (!options) options = { datetimetype: 3, utc: false };
                                case 'DT':
                                case 'DATE_AND_TIME':
                                    if (!options) options = { datetimetype: 1, utc: false };
                                case 'DATE':
                                    if (!options) options = { datetimetype: 0, utc: false };
                                    const val_min_dt = this._filters[field] && this._filters[field]['min'] ? this._filters[field]['min'].value : '';
                                    const val_max_dt = this._filters[field] && this._filters[field]['max'] ? this._filters[field]['max'].value : '';
                                    inputNum.inputBoxDataRange(e, title, { min: val_min_dt, max: val_max_dt }, options, (res) => {
                                        if (res == null) return;
                                        let setFilt = true;
                                        let text = [];
                                        if (typeof res.min !== 'number' && typeof res.max !== 'number') {
                                            delete this._filters[field];
                                            setFilt = false;
                                        } else {
                                            this._filters[field] = {};
                                            if (typeof res.min === 'number') {
                                                this._filters[field]['min'] = {
                                                    field: field,
                                                    type: '>=',
                                                    value: res.min
                                                };
                                                text.push(`>= ${res.min}`);
                                            }
                                            if (typeof res.max === 'number') {
                                                this._filters[field]['max'] = {
                                                    field: field,
                                                    type: '<=',
                                                    value: res.max
                                                };
                                                text.push(`<= ${res.max}`);
                                            }
                                            if (field.indexOf('$') > -1) {
                                                this._filters[field].ref = this._refsTable[field];
                                                this._filters[field].func = this.refFilter.bind(this);
                                                this._filters[field].max && (this._filters[field].max.field = this.refFilter.bind(this, field));
                                                this._filters[field].min && (this._filters[field].min.field = this.refFilter.bind(this, field));
                                            }
                                        }
                                        this._setFilter(col, setFilt, text.join(', '));
                                    });
                                    break;
                                case 'STRING':
                                    const val_str = this._filters[field] ? this._filters[field]['val'].value : '';
                                    inputNum.inputBoxText(e, title, val_str, (res) => {
                                        if (res === null) return;
                                        let setFilt = true;
                                        if (res === '') {
                                            delete this._filters[field];
                                            setFilt = false;
                                        } else {
                                            this._filters[field] = {
                                                val: {
                                                    field: field,
                                                    type: 'like',
                                                    value: res
                                                }
                                            };
                                            if (field.indexOf('$') > -1) {
                                                this._filters[field].ref = this._refsTable[field];
                                                this._filters[field].func = this.refFilter.bind(this, field);
                                                this._filters[field].val.field = this.refFilter.bind(this, field);
                                            }
                                        }

                                        this._setFilter(col, setFilt, `${i18next.t('dictionary_contains')} "${res}"`);
                                    });
                                    break;
                                case 'BOOL':
                                    const val_bool = this._filters[field] ? this._filters[field]['val'].value : 'all';
                                    const opt = [
                                        { value: 'true', name: i18next.t('true') },
                                        { value: 'false', name: i18next.t('false') },
                                        { value: 'all', name: i18next.t('all') }
                                    ]
                                    inputNum.inputBoxSelect(e, title, opt, val_bool.toString(), (res) => {
                                        if (res == null) return;
                                        let setFilt = true;
                                        if (res === '' || res === 'all') {
                                            delete this._filters[field];
                                            setFilt = false;
                                        } else {
                                            this._filters[field] = {
                                                val: {
                                                    field: field,
                                                    type: '=',
                                                    value: this._toBool(res)
                                                }
                                            };
                                            if (field.indexOf('$') > -1) {
                                                this._filters[field].ref = this._refsTable[field];
                                                this._filters[field].func = this.refFilter.bind(this);
                                                this._filters[field].val.field = this.refFilter.bind(this, field);
                                            }
                                        }
                                        this._setFilter(col, setFilt, `${i18next.t("dictionary_equals")} ${res}`);
                                    });
                                    break;
                                case 'BYTE':
                                case 'DINT':
                                case 'INT':
                                case 'LINT':
                                case 'SINT':
                                case 'UDINT':
                                case 'UINT':
                                case 'ULINT':
                                case 'USINT':
                                case 'REAL':
                                case 'LREAL':
                                case 'WORD':
                                case 'LWORD':
                                case 'DWORD':
                                    const val_min = this._filters[field] && this._filters[field]['min'] ? this._filters[field]['min'].value : '';
                                    const val_max = this._filters[field] && this._filters[field]['max'] ? this._filters[field]['max'].value : '';
                                    inputNum.inputBoxNumberRange(e, title, { min: val_min, max: val_max }, (res) => {
                                        if (res == null) return;
                                        let setFilt = true;
                                        let text = [];
                                        if (typeof res.min !== 'number' && typeof res.max !== 'number') {
                                            delete this._filters[field];
                                            setFilt = false;
                                        } else {
                                            this._filters[field] = {};
                                            if (typeof res.min === 'number') {
                                                this._filters[field]['min'] = {
                                                    field: field,
                                                    type: '>=',
                                                    value: res.min
                                                };
                                                text.push(`>= ${res.min}`);
                                            }
                                            if (typeof res.max === 'number') {
                                                this._filters[field]['max'] = {
                                                    field: field,
                                                    type: '<=',
                                                    value: res.max
                                                };
                                                text.push(`<= ${res.max}`);
                                            }
                                            if (field.indexOf('$') > -1) {
                                                this._filters[field].ref = this._refsTable[field];
                                                this._filters[field].func = this.refFilter.bind(this, field);
                                                this._filters[field].max && (this._filters[field].max.field = this.refFilter.bind(this, field));
                                                this._filters[field].min && (this._filters[field].min.field = this.refFilter.bind(this, field));
                                            }
                                        }
                                        this._setFilter(col, setFilt, text.join(', '));
                                    }, { min: window._enums.Types[this._tablecolumns[indexOf].fieldtype].description.min, max: window._enums.Types[this._tablecolumns[indexOf].fieldtype].description.max });
                                    break;
                                default:
                                    const en = DataTypes.dataTypes[this._tablecolumns[indexOf].fieldtype].DisplayValues;
                                    let val_enum;
                                    if (this._filters[field]) {
                                        val_enum = new Array(en.length).fill(false);
                                        this._filters[field].val.value.forEach(el => {
                                            val_enum[el] = true;
                                        });
                                    } else {
                                        val_enum = [];
                                    }
                                    inputNum.inputBoxEnum(e, title, en, val_enum, null, (res) => {
                                        let setFilt = true;
                                        const isFilt = res.reduce((acc, val) => acc += val);
                                        delete this._filters[field];
                                        if (isFilt > 0 && isFilt < en.length) {
                                            this._filters[field] = {}
                                            const inA = []
                                            for (let i = 0; i < res.length; i++) {
                                                if (res[i]) {
                                                    inA.push(i);
                                                }
                                            }
                                            this._filters[field]['val'] = {
                                                field: field,
                                                type: 'in',
                                                value: inA
                                            };

                                        }
                                        this._setFilter(col, setFilt);
                                    });
                            }
                        }
                        return false;
                    }
                },
                // formatter: formatter,
                titleFormatter: (cell, formatterParams, onRendered) => {
                    if (formatterParams.cel.enablefilter) {
                        if ($pm.hasPermissions) {
                            if ($pm.checkAllow($pm.getEntryFromElement(this, 'DirectoryFilter'))) {
                                return `<span class="btn hmi-j-filter"></span>${cell.getValue()}`;
                            } else {
                                return `<span class="btn hmi-j-filter disable"></span>${cell.getValue()}`;
                            }
                        } else {
                            return `<span class="btn hmi-j-filter"></span>${cell.getValue()}`;
                        }
                    }
                    return cell.getValue();
                }
            });
            if (w) {
                this.columns[ind - 1].width = w;
            } else {
                const star = this._tablecolumns[i].columnwidth.split('*').length - 1;
                if (star > 0) {
                    this.columns[ind - 1].widthGrow = star;
                } else {
                    fnSize.innerText = this._tablecolumns[i].displayname;
                    this.columns[ind - 1].width = fnSize.getBoundingClientRect().width + 40;
                }
            }
            this._keyColums[this._tablecolumns[i].field] = {
                cellsstyle: this._tablecolumns[i].cellsstyle
            }
        }

        fnSize.remove();
        colSort.sort((a, b) => {
            return a.position - b.position;
        });
        let isInited = false;
        this.table = new Tabulator(this._main, {
            autoResize: true,
            virtualDom: true,
            virtualDomBuffer: 100,
            index: '$__index',
            layout: 'fitColumns',
            locale: 'ru',
            tooltips: false,
            addRowPos: 'bottom',
            pagination: false,
            movableColumns: true,
            columns: this.columns,
            headerSortTristate: true,
            rowFormatter: (row) => {
                const data = row.getData();
                for (const key in data) {
                    if (this._fieldstyles && this._fieldstyles.hasOwnProperty(key)) {
                        const style = this._fieldstyles[key];
                        for (const k in style) {
                            const el = style[k];
                            const resault = Converter.convert(el, data[key], el.FieldType);
                            const div = row.getElement();
                            this.setStyle(k, resault, div);
                        }
                    }
                    if (this._keyColums && this._keyColums[key] && this._keyColums[key]['cellsstyle']) {
                        if (this._cellsstyle && this._cellsstyle.hasOwnProperty(this._keyColums[key].cellsstyle)) {
                            const style = this._cellsstyle[this._keyColums[key].cellsstyle];
                            for (const k in style) {
                                const el = style[k];
                                const resault = Converter.convert(el, data[el.FieldName], el.FieldType);
                                const cell = row.getCell(key);
                                if (cell) {
                                    const div = row.getCell(key).getElement();
                                    this.setStyle(k, resault, div);
                                }
                            }
                        }

                    }
                }
                row.normalizeHeight();
            },
            langs: {
                'ru': {
                    /*
                    'columns': {
                        'name': 'Название', //replace the title of column name with the value "Name";
                    },*/
                    'pagination': {
                        'first': 'Первая', //text for the first page button
                        'first_title': 'Первая страница', //tooltip text for the first page button
                        'last': 'Последняя',
                        'last_title': 'Последняя страница',
                        'prev': 'Предыдущая',
                        'prev_title': 'Предыдущая страница',
                        'next': 'Следующая',
                        'next_title': 'Следующая страница',
                    },
                }
            },
        });
        this.table.on("dataSorted", (sorter, row) => {
            if (isInited) {
                const sotrOut = [];
                for (let i = 0; i < sorter.length; i++) {
                    const element = sorter[i];
                    sotrOut.push({
                        dir: sorter[i].dir,
                        column: sorter[i].field
                    });
                }
                this.saveItemState({ sorter: sotrOut });
            }
        })
        this.table.on("cellClick", (e, cell) => {
            const fild = cell.getField();
            const row = cell.getRow().getPosition();
            const cellvalue = cell.getValue();
            const cellEl = cell.getElement();
            const r = JSON.parse(JSON.stringify(cell.getData()));
            delete r.$key;
            delete r.$__index;
            const rt = {};
            const rrt = {};
            for (const key in r) {
                if (r.hasOwnProperty(key)) {
                    const newKey = key.replace(/\$/mg, '.')

                    const i = this._mainTable.fields.findIndex(el => el.name === newKey);
                    if (this._mainTable.fields[i].ref) {
                        const path = key.split('.');
                        if (path.length === 2) {
                            rrt[path[0]] = r[key];
                        }
                        if (r[key]) {
                            const i = this._refsTable[key].fields[this._refsTable[key].field];
                            rt[newKey] = this._refsTable[key].data[r[key]][i];
                        }
                    } else {
                        rt[newKey] = r[key];
                        rrt[newKey] = r[key];
                    }
                }
            }
            let event = new CustomEvent('cellclick', { detail: { fild: fild, row: row, rawrowvalue: rrt, rowvalue: rt, cellvalue: cellvalue, el: cellEl, pageX: e.pageX, pageY: e.pageY } });
            this.dispatchEvent(event);
            event = null;
        })
        this.table.on("rowClick", (e, row) => {
            const index = row.getIndex();
            if (this._selectedIndex !== index) {
                this.table.deselectRow(this._selectedIndex);
                this._oldSelectedIndex = this._selectedIndex;
                this._selectedIndex = index;
                this.table.selectRow(this._selectedIndex);
            }
        })
        this.table.on("rowDblClick", (e, row) => {
            if ($pm.hasPermissions) {
                if ($pm.checkAllow($pm.getEntryFromElement(this, 'DirectoryEdit'))) {
                    this._edRec(row);
                }
            } else {
                this._edRec(row);
            }
        })
        this.table.on("tableBuilt", (data) => {
            this.table.setSort(colSort);
            this.table.element.style.width = this.offsetWidth + "px";
            this.table.element.getElementsByClassName('tabulator-tableHolder')[0].style.backgroundColor = this.getAttribute('backgroundcolor');
            this.table.redraw(true);
            let headers = this.table.element.getElementsByClassName('tabulator-col');
            let headertexts = this.table.element.getElementsByClassName('tabulator-col-title');
            for (let i = 0; i < headers.length; i++) {
                headers[i].style.height = this._hHeight > 0 ? this._hHeight : this._headerstyle.height;
                headers[i].style.background = this._headerstyle.backgroundcolor;
                headertexts[i].style.color = this._headerstyle.textcolor;
                headertexts[i].style.fontSize = this._headerstyle.fontsize;
                headertexts[i].style.fontStyle = this._toBool(this._headerstyle.fontitalic) ? 'italic' : 'normal';
                headertexts[i].style.textDecoration = this._toBool(this._headerstyle.fontunderlined) ? 'underline' : '';
                headertexts[i].style.fontWeight = this._toBool(this._headerstyle.fontbold);
                headertexts[i].style.fontFamily = this._headerstyle.fontname;
            }

            if (this.sorter) this.table.setSort(this.sorter);

            isInited = true;
            this.isTableBuilt = true
        })
    }

    refFilter(field, data, filterParams, ff) {
        const fIndex = this._refsTable[field].fields[this._refsTable[field].field]
        // const fIndex = filterParams.ref.fields[filterParams.ref.field];
        if (ff.value) {
            if (typeof data[field] === 'undefined' || data[field] === null) return false;
            const value = this._refsTable[field].data[data[field]][fIndex];
            switch (ff.type) {
                case 'like':
                    return value.toString().toLowerCase().includes(ff.value.toString().toLowerCase());
                case 'in': //enum
                    return true;
                case '=': //bool
                    return this._toBool(value) === this._toBool(ff.value);
                case '>=':
                    return value >= ff.value;
                case '<=':
                    return value <= ff.value;
                default:
                    return true;
            }
        } else if (filterParams.min || filterParams.max) {
            let acuValid = true;
            if (filterParams.min) {
                const value = Number(filterParams.ref.data[data[filterParams.min.field]][fIndex]);
                acuValid = acuValid && (value >= filterParams.min.value);
            }
            if (acuValid && filterParams.max) {
                const value = Number(filterParams.ref.data[data[filterParams.max.field]][fIndex]);
                acuValid = acuValid && (value <= filterParams.max.value);
            }
            return acuValid;
        }
    }

    _setFilter(col, setFilt, text) {
        if ($pm.hasPermissions) {
            const inTable = this._tablecolumns.find((el) => {
                return el.field.replace(/\./mg, '$') === col.getField();
            });
            const options = {
                cancel: () => {
                    this._filters = this._oldFilters;
                },
                customText: `${this.elname}  ${setFilt ? `${i18next.t("dictionary_column_filtering_enabled")} ${inTable.displayname} : ${text}` : `${i18next.t("dictionary_column_filtering_is_disabled")} ${inTable.displayname}`}`
            }
            // "Включена фильтрация столбца <имя столбца> : <параметры фильтрации>", "Отключена фильтрация столбца <имя столбца>"
            $pm.resolveControl(this, "DirectoryFilter", this._successSetFilter.bind(this, col, setFilt), options);
        } else {
            this._successSetFilter(col, setFilt);
        }
    }

    _setFilterToTable() {
        this.table.clearFilter();
        for (const key in this._filters) {
            const el = this._filters[key];
            for (const k in el) {
                if (k !== 'ref' && k !== 'func') {
                    const e = el[k];
                    this.table.addFilter(e.field, e.type, e.value);
                }
            }
        }
    }
    _successSetFilter(col, setFilt) {
        this.saveItemState({ filrets: this._filters });
        this._setFilterToTable();
        if (setFilt) {
            if (this._headerstyle && this._headerstyle.backgroundcolorfilter) {
                col.getElement().style.backgroundColor = this._headerstyle.backgroundcolorfilter;
                col.getElement().firstChild.firstChild.style.color = this._headerstyle.textcolorfilter;
            } else {
                col.getElement().style.filter = `brightness(${this._headerAkcent})`;
            }
        } else {
            if (this._headerstyle && this._headerstyle.backgroundcolorfilter) {
                col.getElement().style.backgroundColor = this._headerstyle.backgroundcolor;
                col.getElement().firstChild.firstChild.style.color = this._headerstyle.textcolor;
            } else {
                col.getElement().style.filter = '';
            }
        }
    }

    _updateData() {

        this._tabledata = [];

        for (const key in this._mainTable.data) {
            const el = this._mainTable.data[key];
            const newItem = {
                '$__index': key,
                '$key': key
            };

            for (let i = 0; i < this._mainTable.fields.length; i++) {
                const f = this._mainTable.fields[i];
                newItem[f.name.replace(/\./mg, '$')] = el[i];
            }
            this._tabledata.push(newItem);
        }

        let s;
        this.table.blockRedraw();
        // if (this._tabledata.length < this.table.getDataCount()) {
        //     const offset = this.table.getDataCount() - this._tabledata.length;
        //     for (let i = this.table.getDataCount() - offset; i < this.table.getDataCount(); i++) {
        //         this.table.deleteRow(this.table.getDataCount() - 1);
        //     }
        // }
        this.table.clearData();
        this.table.addData(this._tabledata);

        const filters = this.table.getFilters();

        if (filters.length > 0) {
            this.table.clearFilter();
            this.table.setFilter(filters);
            s = this.table.element.getElementsByClassName('tabulator-tableHolder')[0].scrollTop;
        }
        const sorter = this.table.getSorters();
        if (sorter.length > 0) {
            this.table.setSort(sorter);
            s = this.table.element.getElementsByClassName('tabulator-tableHolder')[0].scrollTop;
        }

        this.table.restoreRedraw();
        if (typeof s === 'number') this.table.element.getElementsByClassName('tabulator-tableHolder')[0].scrollTop = s;
    }

    _addRec() {
        if (this._disableadd || this._openDisabled) return;
        this._openDisabled = true;
        const html = this._generateForm();
        this._inputs = new Inputs(this._in);
        const elRect = this.getBoundingClientRect();
        const sc = elRect.width / this.width;

        this._inputs.inputBoxCustom(null, html, null, (v) => {
            if ($pm.hasPermissions) {
                const form = v.querySelector('form');
                const fields = JSON.parse(form.dataset.fields).map(el => { return el.split('.')[0]; });
                const data = this._extractValue(form);
                const txtFildList = [];
                const item = {};
                for (let i = 0; i < fields.length; i++) {
                    item[fields[i]] = data[i];
                }
                for (const key in item) {
                    if (item.hasOwnProperty(key)) {
                        if (!key.startsWith('$')) {
                            txtFildList.push(` ${key}=${item[key]}`);
                        }
                    }
                }
                const option = { customText: `${this.elname} ${i18next.t("dictionary_adding_a_record")} :${txtFildList.join(',')}` };
                $pm.resolveControl(this, "DirectoryAdd", this._successAdd.bind(this, v), option);
            } else {
                this._successAdd(v);
            }
        }, {
            toBody: false,
            alignToElement: true,
            element: this,
            showFocus: false,
            msPopup: true,
            scale: sc,
            title: i18next.t("dictionary_addition"),
            onCancel: (e) => {
                this._openDisabled = false;
            }
        });
    }
    _successAdd(v) {
        const form = v.querySelector('form');
        const fields = JSON.parse(form.dataset.fields);
        this._openDisabled = false;
        const pack = {
            table: this._dictId,
            fields: fields.map(el => { return el.split('.')[0]; }),
            data: this._extractValue(form)
        };
        this._addTable(pack);
    }

    _edRec(row) {
        if (this._disableedit) return;
        if (this._openDisabled) {
            this._inputs.close();
            this._openDisabled = false;
        }
        const item = row && row.getData && [row.getData()] || this.table.getSelectedData();
        if (item.length > 0) {
            this._openDisabled = true;
            const elRect = this.getBoundingClientRect();
            const sc = elRect.width / this.width;
            this._inputs = new Inputs(this._in);
            const html = this._generateForm(item[0]);
            this._inputs.inputBoxCustom(null, html, null, (v) => {
                if ($pm.hasPermissions) {
                    const form = v.querySelector('form');
                    const fields = JSON.parse(form.dataset.fields).map(el => { return el.split('.')[0]; });
                    const data = this._extractValue(form);
                    const items = {};
                    for (let i = 0; i < fields.length; i++) {
                        items[fields[i]] = data[i];
                    }
                    const txtFildList = [];
                    for (const key in items) {
                        if (items.hasOwnProperty(key)) {
                            if (!key.startsWith('$')) {
                                txtFildList.push(` ${key}=${items[key]}`);
                            }
                        }
                    }
                    const option = { customText: `${this.elname} ${i18next.t("dictionary_changing_an_entry")} :${txtFildList.join(',')}` };
                    $pm.resolveControl(this, "DirectoryEdit", this._successEdit.bind(this, v, item), option);
                } else {
                    this._successEdit(v, item);
                }
            }, {
                toBody: false,
                alignToElement: true,
                element: this,
                showFocus: false,
                msPopup: true,
                scale: sc,
                title: i18next.t("dictionary_editing"),
                afterInit: (nodes) => {
                    const el = nodes.querySelectorAll('input[lenHelper]')
                    for (const iterator of el) {
                        iterator.oninput = this._lenHelper;
                    }
                },
                onCancel: (e) => {
                    this._openDisabled = false;
                }
            });
        }
    }

    _successEdit(v, item) {
        const form = v.querySelector('form');
        const fields = JSON.parse(form.dataset.fields);
        this._openDisabled = false;
        const pack = {
            table: this._dictId,
            fields: fields.map(el => { return el.split('.')[0]; }),
            data: {}
        }
        pack.data[item[0].$key] = this._extractValue(form);
        this._updateTable(pack);
        delete this._inputs;
    }

    _delRec() {
        if (this._disabledelete) return;
        const item = this.table.getSelectedData();
        if (item.length > 0) {
            $confirm(() => {
                const pack = {
                    table: this._dictId,
                    recs: [item[0].$key]
                }
                if ($pm.hasPermissions) {
                    const txtFildList = [];
                    for (const key in item[0]) {
                        if (item[0].hasOwnProperty(key)) {
                            if (!key.startsWith('$')) {
                                txtFildList.push(` ${key}=${item[0][key]}`);
                            }
                        }
                    }
                    const option = { customText: `${this.elname} ${i18next.t("dictionary_deleting_a_record")} :${txtFildList.join(',')}`, forced: true };
                    $pm.resolveControl(this, "DirectoryDelete", this._deleteFromTable.bind(this, pack), option);
                } else {
                    this._deleteFromTable(pack);
                }
            }, `${i18next.t("delete")} ${item[0][this._displayField] || ''}?`);
        }
    }

    enums(type) {
        if (!this._enums) {
            this._enums = {};
        }
        if (!this._enums[type]) {
            if (DataTypes.dataTypes[type] && DataTypes.dataTypes[type].DataType !== `ElementaryType`) {
                this._enums[type] = {};
                const en = DataTypes.dataTypes[type].DisplayValues;
                for (let i = 0; i < en.length; i++) {
                    const el = en[i];
                    this._enums[type][i] = el;
                    this._enums[type][el] = i;
                }
            }
        }
        return this._enums[type];
    }

    _extractValue(form) {
        const res = [];
        for (let i = 0; i < form.length; i++) {
            const el = form[i];
            let item = '';
            switch (_enums.Types[el.dataset.type].type) {
                case 'number':
                case 'wordNumber':
                    item = Number(el.value) || '';
                    break;
                case 'boolean':
                    item = this._toBool(el.checked)
                    break;
                case 'date':
                    item = el.value;
                    if (item > 0) {
                        const timeOffset = new Date(item).getTimezoneOffset() * 60000;
                        item = item - timeOffset;
                    }
                    break;
                default:
                    item = el.value;
            }
            res.push(item);
        }
        return res;
    }

    _generateForm(values) {
        if (!values) values = {};
        let res = '';
        let fields = [];
        for (let i = 0; i < this._mainTable.fields.length; i++) {
            const inTable = this._tablecolumns.find((el) => {
                return el.field === this._mainTable.fields[i].name;
            });
            if (typeof inTable === 'undefined' || inTable.disableedit) continue;
            fields.push(this._mainTable.fields[i].name);
            res += '<tr>';
            const el = this._mainTable.fields[i];
            if (el.ref) {
                const key = el.name.replace(/\./mg, '$');
                const p = this._refsTable[key].fields[this._refsTable[key].field]
                let options = '';
                for (const k in this._refsTable[key].data) {
                    const dictEl = this._refsTable[key].data[k];
                    const sel = values[key] == k ? ' selected' : '';
                    options += `<option${sel} value="${k}">${dictEl[p] || dictEl}</option>`;
                }
                res += `<td>${this._tablecolumns[i].displayname}</td>
                        <td><select data-type="${el.type}" id="${this._refsTable[key].field}" name="${this._refsTable[key].field}">${options}</select></td><td></td>`;

            } else {
                if (_enums.Types[el.type]) {
                    let val = values[el.name];
                    switch (_enums.Types[el.type].type) {
                        case 'string':
                            if (val === undefined) val = '';
                            let maxLen = '';
                            let lenHelp = '';
                            let onInput = '';
                            if (this._tablecolumns[i].valueformat) {
                                val = getFormattedValue(this._tablecolumns[i].valueformat, val.trimRight());
                                const tf = /^[t].?\d?$/i.test(this._tablecolumns[i].valueformat);
                                if (tf) {
                                    const len = this._tablecolumns[i].valueformat.slice(1);
                                    maxLen = len ? ` maxlength="${len}"` : '';
                                    lenHelp = len ? `<span id="lh" style="color:gray;font-size:60%;">(${val.length}/${len})</span>` : '';
                                    onInput = len ? ` lenHelper` : '';
                                }
                            }
                            res += `<td>${this._tablecolumns[i].displayname}</td>
                                <td><input${onInput} data-type="${el.type}" type="text" id="${el.name}" name="${el.name}" value="${val || ''}"${maxLen}></td><td>${lenHelp}</td>`;
                            break;
                        case 'boolean':
                            const ch = typeof val === 'boolean' && val ? ' checked' : '';
                            res += `<td>${this._tablecolumns[i].displayname}</td>
                                <td><input data-type="${el.type}" type="checkbox" id="${el.name}" name="${el.name}" value="${val || false}"${ch}></td><td></td>`;
                            break;
                        case 'number':
                        case 'wordNumber':
                            const max = _enums.Types[el.type].description.max ?? Infinity;
                            const min = _enums.Types[el.type].description.min ?? -Infinity;
                            res += `
                                <td>${this._tablecolumns[i].displayname}</td>
                                <td>
                                    <ms-numericupdown
                                        showbuttons="false"
                                        data-type="${el.type}"
                                        backgroundcolor=""
                                        allownull="true"
                                        id="${el.name}"
                                        name="${el.name}"
                                        maxdecimalplaces=100
                                        value="${val || ''}"
                                        minvalue="${min}"
                                        maxvalue="${max}"
                                        style="width:100%;height: 1.5em;border:1px solid;position:relative;"
                                    ></ms-numericupdown>
                                </td>
                                <td></td>
                            `;
                            break;
                        case 'date':
                            if (val > 0) {
                                const timeOffset = new Date(val).getTimezoneOffset() * 60000;
                                val = val + timeOffset;
                            }
                            let datetimetype = 1;
                            if (_enums.Types[el.type].description.descType === 'tod') {
                                datetimetype = 3;
                            }
                            res += `<td>${this._tablecolumns[i].displayname}</td>
                                <td><ms-dtpicker data-type="${el.type}" utc="false" backgroundcolor="" id="${el.name}" isreadonly="false" allownull="true" datetimetype="${datetimetype}" name="${el.name}" value="${val || ''}" style="width:100%;border:1px solid;position:relative;"></ms-dtpicker></td><td></td>`;
                            break;
                        default:
                            break;
                    }
                }
            }
            res += '</tr>';

        }
        return `<style>
        #inputbody {
            width: max-content;
            min-width: 320px;
            margin: 5px;
        }
        td {
            padding: 2px 0;
        }
        tr input,select{
            width: 100%;
            border: gray 1px solid;
            height: 1.5em;
        }
        tr input,select :not(:last-child){
            margin: 2px 0;
        }</style>
        <form style="display: flex; flex-direction: column;" data-fields='${JSON.stringify(fields)}'><table>${res}</table></form>`;
    }

    _lenHelper(e) {
        const max = e.target.getAttribute('maxlength')
        const span = e.target.parentNode.parentNode.querySelector("#lh")
        span.innerHTML = ` (${e.target.value.length}/${max})`;

    }

    DownloadCsv() {
        const fileName = this.elname + ".csv";

        if ($pm.hasPermissions) {
            const options = {
                cancel: () => { },
                customText: window.savePath
                ? `${i18next.t("dictionary_export_data")} : ${elname} (${window.savePath}${fileName})${window.saveDeviceDesc}`
                : `${i18next.t("dictionary_export_data")} : ${elname}`,
        };
            $pm.resolveControl(
                this,
                "DictionarySave",
                this._DownloadCsv.bind(this, fileName),
                options
            );
        } else this._DownloadCsv(fileName);
    }

    _DownloadCsv(fileName) {
        const resultTable = this.table.getRows().map(x => x.getCells().map(y => y.getElement().textContent));
        let res = "\uFEFF";
        const headerRow = this._tablecolumns.map(col => col.displayname).join(";") + "\n";
        res += headerRow;
        for (const row of resultTable) {
            res += `${row.join(";")}\n`;
        }
        exportTextfile(res, fileName, true);
    }

    connectedCallback() {
        super.connectedCallback();
        if (typeof this.saveStateFlag === 'undefined') {
            this.saveStateFlag = this.calcSaveState();
        }
        if (this.saveStateFlag) {
            this.updateItemState();
        }
        this._createTable();
        if (this.filrets) this.filrets = this.filrets;
        if (this.sorter) this.sorter = this.sorter;
        this._getTable();
        this._inited = true;
    }

    disconnectedCallback() {
        if (this._inputs) {
            this._inputs.close();
            delete this._inputs;
        }
        window.removeEventListener("ms_message", this.afterSwitch);
        if (this.table && this.table.destroy) {
            this.table.destroy();
            this.table = null;
        }
        super.disconnectedCallback();
    }
}